document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll(".bp-footer details").forEach((item) => {

    item.addEventListener("toggle", () => {

      if (item.open) {

        document.querySelectorAll(".bp-footer details").forEach((other) => {

          if (other !== item) {
            other.removeAttribute("open");
          }

        });

      }

    });

  });

});